export default "__VITE_ASSET__bd7dfd82__"